import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { UpdateFormDto, UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_FORMS } from "../domain";

import { formsApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_CREATE_FORM = "CREATE_FORM";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

type UpdateFormRequest = {
  formId: string;
  data: UpdateFormDto;
};

const updateForm = async (req: UpdateFormRequest): Promise<void> => {
  const response = await formsApi.formsControllerUpdateForm(req.formId, req.data);

  return response.data;
};

export const useUpdateForm = (
  user: UserProfileDto | null,
): {
  updateForm: UseMutateFunction<void, Error, UpdateFormRequest, unknown>;
  updateFormEnabled: boolean;
  isSuccessUpdateForm: boolean;
  isPendingUpdateForm: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_FORMS],
    mutationFn: enabled ? updateForm : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_FORMS] });
    },
  });

  return {
    updateForm: mutate,
    updateFormEnabled: enabled,
    isSuccessUpdateForm: isSuccess,
    isPendingUpdateForm: isPending,
  };
};
